import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./panelHeader.html";
import { SOURCE_LOGIN_CARD_NUMBER, TARGET_LOGIN_CARD_NUMBER } from '../utils/appConstants';
class PanelHeader extends LightningElement {
  constructor() {
    super();
    this.title = void 0;
    this.menuTitle = void 0;
    this.panelHeaderHeight = void 0;
    this.panelHeaderWidth = void 0;
    this.menuOptions = void 0;
    this.enableOptions = void 0;
    this.isModalOpen = void 0;
    this.cardNumber = void 0;
    this.handleMenuSelect = event => {
      const selectedOption = event.target.textContent;
      if (selectedOption === 'Properties') {
        this.template.querySelector('.slds-dropdown-trigger').classList.remove('slds-is-open');
        const modalDetails = {
          'isModalOpen': true
        };
        if (this.cardNumber === SOURCE_LOGIN_CARD_NUMBER) {
          const sourceModalOpenEvent = new CustomEvent("sourcepropertiesmodal", {
            detail: modalDetails
          });
          this.dispatchEvent(sourceModalOpenEvent);
        } else if (this.cardNumber === TARGET_LOGIN_CARD_NUMBER) {
          const targetModalOpenEvent = new CustomEvent("targetpropertiesmodal", {
            detail: modalDetails
          });
          this.dispatchEvent(targetModalOpenEvent);
        }
      } else if (selectedOption === 'Disconnect') {
        if (this.cardNumber === SOURCE_LOGIN_CARD_NUMBER) {
          const logoutSourceOrgEvent = new CustomEvent("logoutsourceorg", {});
          this.dispatchEvent(logoutSourceOrgEvent);
        } else if (this.cardNumber === TARGET_LOGIN_CARD_NUMBER) {
          const logoutDestinationOrgEvent = new CustomEvent("logoutdestinationorg", {});
          this.dispatchEvent(logoutDestinationOrgEvent);
        }
      } else if (selectedOption === 'Back') {
        const backButtonEvent = new CustomEvent("backbuttonclick", {});
        this.dispatchEvent(backButtonEvent);
      }
    };
    this.showOptions = () => {
      this.template.querySelector('.slds-dropdown-trigger').classList.add('slds-is-open');
    };
    this.hideOptions = () => {
      this.template.querySelector('.slds-dropdown-trigger').classList.remove('slds-is-open');
    };
    this.closeOptionsMenu = () => {
      let componentClick = false;
      document.addEventListener("click", () => {
        if (!componentClick) {
          this.hideOptions();
        }
        ;
      });
      this.template.addEventListener("click", () => {
        componentClick = true;
        setTimeout(() => {
          componentClick = false;
        }, 300);
      });
    };
    this.closeOptionsMenu();
  }
  renderedCallback() {
    if (this.template.querySelector('div[data-my-id="panelHeaderDiv"]') !== null && this.template.querySelector('div[data-my-id="panelHeaderDiv"]') !== undefined) {
      this.template.querySelector('div[data-my-id="panelHeaderDiv"]').style.maxHeight = '40px';
      this.template.querySelector('div[data-my-id="menuOptionsDiv"]').style.display = this.enableOptions ? 'block' : 'none';
    }
  }
}
_registerDecorators(PanelHeader, {
  publicProps: {
    title: {
      config: 0
    },
    menuTitle: {
      config: 0
    },
    panelHeaderHeight: {
      config: 0
    },
    panelHeaderWidth: {
      config: 0
    },
    menuOptions: {
      config: 0
    },
    enableOptions: {
      config: 0
    },
    isModalOpen: {
      config: 0
    },
    cardNumber: {
      config: 0
    }
  },
  fields: ["handleMenuSelect", "showOptions", "hideOptions", "closeOptionsMenu"]
});
export default _registerComponent(PanelHeader, {
  tmpl: _tmpl
});